import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useGetUserQuarriesForClaimQuery } from '@api/queries';
import { useCountDownBoostsTimers } from '@common/hooks/count-down-boosts-timers';
import TabsBody from '@components/Resources/TabsBody/TabsBody';
import { PageBackground } from '@components/ui/Backgrounds/PageBackground/PageBackground';
import { boostQuarryTimersEnd } from '@redux/selectors/quarrySelectors';
import { useAppSelector } from '@redux/store';

import { useExtendedInfoQuery } from '@/api/queries/user';
import { BACKGROUNDS_CONFIG } from '@/common/config/media-config';

const Resources: React.FC = () => {
  useExtendedInfoQuery();
  const quarries = useAppSelector(
    (state) => state.quarry.quarries?.userQuarries,
  );
  const isTimersEnd = useAppSelector(boostQuarryTimersEnd);
  useCountDownBoostsTimers(!isTimersEnd, 'Quarry');

  useGetUserQuarriesForClaimQuery(undefined, {
    refetchOnMountOrArgChange: true,
  });

  if (!quarries) {
    return null;
  }

  // if (quarries.length === 0) {
  //   return <Navigate to={AppRoute.RESOURCES + '/build'} replace={true} />;
  // }

  return (
    <main className="h-full flex flex-col justify-between !mb-0">
      <Helmet>
        <title>Resources</title>
      </Helmet>
      <PageBackground
        className="!h-auto"
        variant="page"
        backgroundImage={{
          png: BACKGROUNDS_CONFIG.BG_RESOURCE.png,
          webp: BACKGROUNDS_CONFIG.BG_RESOURCE.webp,
        }}
      />
      <div className="tabs tabs--sticky flex-1">
        <TabsBody />
      </div>
    </main>
  );
};

export default Resources;
